import React from 'react';
import PropTypes from 'prop-types';

function DemoGo({ content, closed = () => {} }) {
  return (
    <div className="go">
      <div className="row">
        <div className="col-lg-6 col-lg-offset-3 col-md-6 col-md-offset-3 col-sm-8 col-sm-offset-2 col-xs-10 col-xs-offset-1 padding-top text-center">
          <h1>{content.DemoReadyGo}</h1>
          <a className="help_btn" onClick={closed}>
            {content.DemoDone}
          </a>
        </div>
      </div>
    </div>
  );
}

DemoGo.propTypes = {
  content: PropTypes.object,
  closed: PropTypes.func,
};

export { DemoGo };
